var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaratDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 9
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.221.5l1.393 1.393L7.007 8.5.4 1.893 1.793.5l5.214 5.213z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSI5IiBmaWxsPSIjZmZmZmZmIj4KICAgIDxwYXRoIGQ9Ik0xMi4yMjEuNWwxLjM5MyAxLjM5M0w3LjAwNyA4LjUuNCAxLjg5MyAxLjc5My41bDUuMjE0IDUuMjEzeiIgZmlsbD0iI2ZmZmZmZiIgLz4KPC9zdmc+Cg==";
export { SvgCaratDown as ReactComponent };